<template>
  <button
    :class="{ active: activeChannel === channelKey }"
    @click="$emit('channelClicked', channelKey)"
  >
    <span class="icon">
      <img :src="channelIcon" />
    </span>
    <span>{{ channelData.title }}</span>
  </button>
</template>

<script>
export default {
  data() {
    return {}
  },
  components: {},
  props: ['channelData', 'channelKey', 'activeChannel', 'channelIcon'],
  methods: {},
}
</script>

<style scoped>
button {
  border-radius: 7px;
  padding: 9px 15px;
  background: var(--bg-surface-2);
  color: var(--text-secondary2);
}
.icon {
  margin-right: 10px;
}
.active {
  background: var(--main-color);
  color: #ffffff;
}
</style>
